import { Widget } from "@/modules";

export const GHOST_WIDGETS = ["budget-tickers-group-by-product"];

export const IFRAME_DEFAULT_HEIGHT = "603px";

export const hasMultiFiltersEnabled = (widget: Widget, widgetData: Widget["data"]) => {
    if (widget.type === "table") {
        const hasRowsToFilter = (widgetData?.data?.rows ?? []).length > 0;
        return hasRowsToFilter;
    }

    if (widget.type === "chart") return ["bar", "line"].includes(widget.chartType ?? "");
    return false;
};
